import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: resetFavorites } = actions;

export * from './thunks';
export * from './actions';
export * as favoritesSelectors from './selectors';

export default reducer;
